<template>
  <ValidationObserver ref="form" tag="div" class="mt-3 mb-3 position-relative">
    <div class="loader absolute" v-if="loading"></div>
    <h5 v-if="create" class="text-center mb-3">Créer un utilisateur</h5>
    <ValidationProvider vid="pseudo" name="pseudo" tag="div" rules="required" v-if="create" v-slot="{ errors }"
                        class="form-group row">
      <label for="pseudo" class="col-md-4 col-form-label">Pseudo</label>
      <div class="col-md-8">
        <input id="pseudo" class="form-control" v-model="user.pseudo" type="text" required
               :class="{'is-invalid':!!errors[0]}"/>
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>

    <ValidationProvider vid="first_name" name="first_name" tag="div" rules="required" class="form-group row"
                        v-slot="{ errors }">
      <label for="first_name" class="col-md-4 col-form-label">Nom</label>
      <div class="col-md-8">
        <input id="first_name" class="form-control" v-model="user.first_name" type="text" required
               :class="{'is-invalid':!!errors[0]}"/>
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>

    <ValidationProvider vid="last_name" name="last_name" class="form-group row" rules="required" v-slot="{ errors }">
      <label for="last_name" class="col-md-4 col-form-label">Prenom</label>
      <div class="col-md-8">
        <input id="last_name" class="form-control" v-model="user.last_name" type="text" required
               :class="{'is-invalid':!!errors[0]}"/>
      </div>
    </ValidationProvider>
    <ValidationProvider name="email" tag="div" rules="required" class="form-group row" v-slot="{ errors }">
      <label class="col-md-4 col-form-label">Adresse mail</label>
      <div class="col-md-8">
        <input class="form-control" v-model="user.email" type="email" required :class="{'is-invalid':!!errors[0]}">
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>
    <ValidationProvider v-if="student" tag="div" rules="required" class="form-group row" v-slot="{ errors }">
      <label class="col-md-4 col-form-label">Salle de cours</label>
      <div class="col-md-8">
        <b-form-select v-model="user.classroom_id" :options="classroomOptions"
                       :class="{'is-invalid':!!errors[0]}"></b-form-select>
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>

    <ValidationProvider rules="required" tag="div" class="form-group row" v-slot="{ errors }">
      <label class="col-md-4 col-form-label">Sexe</label>
      <div class="col-md-8">
        <b-form-select v-model="user.gender" :options="gender" :class="{'is-invalid':!!errors[0]}"></b-form-select>
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>
    <ValidationProvider rules="required" tag="div" class="form-group row" v-slot="{ errors }">
      <label class="col-md-4 col-form-label">Ville</label>
      <div class="col-md-8">
        <input class="form-control" v-model="user.city" type="text" required :class="{'is-invalid':!!errors[0]}">
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>

    <ValidationProvider rules="required" tag="div" class="form-group row" v-slot="{ errors }">
      <label class="col-md-4 col-form-label">
        Date de naissance:
      </label>
      <div class="col-md-8">
        <flat-pickr :config="{...configDate,...{defaultDate: user.birth_date}}" :class="{'is-invalid':!!errors[0]}"
                    v-model="user.birth_date" id="day"
                    class="form-control bg-white" name="birth_date"/>
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>

    <ValidationProvider rules="required" tag="div" class="form-group row" v-slot="{ errors }">
      <label class="col-md-4 col-form-label">Telephone</label>
      <div class="col-md-8">
        <input class="form-control" v-model="user.phone" type="text" required
               :class="{'is-invalid':!!errors[0]}">
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>

    <ValidationProvider v-if="create" name="password" rules="required" tag="div" class="form-group row"
                        v-slot="{ errors }">
      <label class="col-md-4 col-form-label">Mot de passe</label>
      <div class="col-md-8">
        <input :class="{'is-invalid':!!errors[0]}" class="form-control" v-model="user.password" type="password"
               required>
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>

    <ValidationProvider v-if="create" name="confirm_password" rules="required|confirmed:password" tag="div"
                        class="form-group row" v-slot="{ errors }">
      <label class="col-md-4 col-form-label">Confirmer le mot de passe</label>
      <div class="col-md-8">
        <input v-model="user.confirm_password" type="password" class="form-control" required
               :class="{'is-invalid':!!errors[0]}">
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>

    <div class="d-flex justify-content-end">
      <b-button squared variant="primary" @click.prevent="onSubmit">{{ create ? 'Créer' : 'Modifier' }}</b-button>
    </div>
  </ValidationObserver>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "Profile",
  props: {
    userData: {type: Object},
    student: {type: Boolean, default: false}
  },
  data() {
    return {
      gender: [{value: 'M', text: 'Homme'}, {value: 'F', text: 'Femme'}],
      configDate: {
        enableTime: false,
        dateFormat: 'Y-m-d',
      },
      user: {
        id: null,
        first_name: '',
        last_name: '',
        pseudo: '',
        email: '',
        gender: '',
        phone: '',
        birth_date: '',
        city: '',
        password: '',
        confirm_password: '',
        classroom_id: ''
      },
      loading: false
    }
  },
  watch: {
    userData(val) {
      this.init(val)
    }
  },
  computed: {
    create() {
      return !this.user.id
    },
    ...mapGetters(['classrooms']),
    classroomOptions() {
      return [
        {value: '', text: 'Choisir une classe', 'disabled': true},
        ...this.classrooms.map(c => ({value: c.id, text: c.name}))
      ]
    }
  },
  methods: {
    onSubmit() {
      console.log(this.user)
      this.$refs.form.validate()
        .then(result => {
          if (result) {
            const data = {
              'pseudo': this.user.pseudo,
              'first_name': this.user.first_name,
              'last_name': this.user.last_name,
              'email': this.user.email,
              'gender': this.user.gender,
              'city': this.user.city,
              'phone': this.user.phone,
              'birth_date': this.user.birth_date,
              'password': this.user.password,
              'classroom_id': this.user.classroom_id,
              'type': this.student ? 'student' : 'parent'
            }
            this.loading = true
            axios.post(this.user.id ? `/user/${this.user.id}/profile` : '/user', data)
              .then(({data}) => {
                if (this.user.id) {
                  // update success
                  this.$toast.fire({
                    title: 'Vos modifications ont été appliquées',
                    icon: 'success'
                  })
                } else {
                  // create success
                  if (this.student) {
                    this.$store.commit('append_children', data)
                  } else {
                    this.$store.commit('append_parent', data)
                  }
                  this.$emit('set-active', data)
                  this.$toast.fire({
                    title: 'Le compte utilisateur a été créé',
                    icon: 'success'
                  })
                }
              })
              .catch(error => {
                console.log(error)
                this.$toast.fire({
                  title: 'Une erreur est survenue',
                  icon: 'error'
                })
                this.displayServerError(error.response.data)
              })
              .finally(() => this.loading = false)
          }
        })
    },
    displayServerError(data) {
      this.$refs.form.setErrors({
        pseudo: data.errors.pseudo,
        email: data.errors.email,
        first_name: data.errors.first_name,
        last_name: data.errors.last_name,
        phone: data.errors.phone,
      });
    },
    init(data) {
      const keys = ['id', 'first_name', 'last_name', 'pseudo', 'email', 'city', 'phone', 'classroom_id', 'password', 'confirm_password', 'birth_date', 'gender']
      if (data.id) {
        keys.forEach(k => this.user[k] = data[k])
      } else {
        keys.forEach(k => this.user[k] = '')
      }
      this.$refs.form.reset()
    }
  },
  mounted() {
    this.init(this.userData)
  }
}
</script>

<style scoped>

</style>
